<script>
	import Navigation from './Navigation.svelte';
	import About from "./About.svelte";
	import Title from './Title.svelte';
	import Therapy from './Therapy.svelte';
	import Education from './Education.svelte';
	import Contact from './Contact.svelte'
	import FormSuccess from './FormSuccess.svelte';
	import Footer from './Footer.svelte';
	import LegalNotice from './LegalNotice.svelte';
	import PrivacyPolicy from './PrivacyPolicy.svelte';
	
	const ESC = 'Escape';
	
	let showPrivacyModal = false;
  	let showLegalNotice = false;
	let location = window.location.href.split('#')[1];
	
	const onClickSection = (section) => {
		location = section;
	}

	const togglePrivacyPolicy = (e) => {
    	e.preventDefault();
    	showPrivacyModal = !showPrivacyModal;
  	}

  	const toggleLegalNotice = (e) => {
    	e.preventDefault();
    	showLegalNotice = !showLegalNotice;
  	}


  	const handleKeydown = (e) => {
    	if (e.key === ESC) {
			showPrivacyModal = false;
			showLegalNotice = false;
    }
  }

</script>
<svelte:window on:keydown={handleKeydown} />
<main>
	<div class='navigation'>
		<Navigation location={location} onClickSection={onClickSection} />
	</div>
	<div class='content'>
		{#if !location}
			<Title />
		{:else if location === 'about'}
			<About/>
		{:else if location === 'education'}
			<Education />
		{:else if location.includes('therapy')} 
			<Therapy {onClickSection} />
		{:else if location === 'contact'}
			<Contact {onClickSection} {togglePrivacyPolicy} />
		{:else if location === 'form-success'}
			<FormSuccess />
		{/if}
	</div>
	<img class={!location? 'expanded' : ''} src='/images/background.jpg' width="100%"  height="100%" alt='imagen-fondo-pluma-paz' />
	{#if location} 
		<Footer {toggleLegalNotice} {togglePrivacyPolicy} />
	{/if}
	<div class={`modal ${showLegalNotice?'': 'hidden'}`} on:click={toggleLegalNotice}>
		<div class='modal-content'>
		<div on:click={(e) => e.stopPropagation()}>
			<span on:click={toggleLegalNotice} class="close">&times;</span>
			<LegalNotice />
		</div>
		</div> 
	</div>

	<div class={`modal ${showPrivacyModal?'': 'hidden'}`} on:click={togglePrivacyPolicy}>
		<div class='modal-content'>
		<div on:click={(e) => e.stopPropagation()}>
			<span on:click={togglePrivacyPolicy} class="close">&times;</span>
			<PrivacyPolicy />
		</div>
		</div>
	</div>
</main>


<style>

	main :global(p) {
        font-size: 20px;
        white-space: pre-line;
    }

	main {
		font-family: 'Benne', serif;
		color:black;
		text-align: justify;
		align-items: center;
		width: 100%;
		height: 100%;
		display: grid;
  		grid-template-columns: 1fr 1fr 1fr;
		grid-template-rows: 60px 1fr;
		grid-template-areas:
			"navigation navigation navigation"
			"content content image"
	}
	
	main :global(a) {
			color: black;
	}

	.navigation {
		grid-area: navigation;
		margin-top: 10px;
		padding: 8px;
	}
	
	.content {
		grid-area: content;
		width: 100%;
		height: 100%;
		margin-left: 50px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;

		line-height: 1.5;
	}

	img {
		grid-area: image;
		grid-row: 1 / 3;
		z-index: -1000;
	}


	.modal {
		position: fixed;
		z-index: 1;
		left: 0;
		top: 0;
		height: 100%;
		width: 100%;
		background-color: rgb(0, 0, 0);
		background-color: rgba(0, 0, 0, 0.4);
	}

	.modal-content {
		background-color: #fff;
		margin: 15% auto;
		/* 15% from the top and centered */
		padding: 40px;
		overflow: auto;
		height: 50%;
		width: 50%;
		/* Could be more or less, depending on screen size */
	}

	.modal-content .close {
		float: right;
		font-size: 30px;
		cursor: pointer;
	}

	.modal.hidden {
		display: none;
	}

	@media (max-width:1350px)  { 
		.modal-content {
    		width: 80%;
  		}

		main {
			grid-template-columns: 1fr;
			grid-template-rows: 60px 1fr;
			grid-template-areas:
			"navigation"
			"content"
		}

		.content {
			width: 80%;
			margin-left: 30px;
			margin-right: 20px;
		}
	

		img {
			opacity: 0.6;
			object-fit: cover;
			grid-row: 1;
			grid-column: 1;
			z-index: -1000;
		}

		img.expanded {
			opacity: 0.6;
			grid-row: 1 /3;
		}

	}

</style>